<router-outlet></router-outlet>

@if (showAlerts()) {
  <app-alerts></app-alerts>
}

<app-loader></app-loader>

<app-confirmation-modal></app-confirmation-modal>